var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tooltip",class:[{ open: _vm.open }, _vm.position, _vm.className]},[_c('div',{staticClass:"tooltip-arrow"}),_c('div',{staticClass:"tooltip-content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }